"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdjustmentDataCollection = void 0;
var _utils = require("@/utils/utils");
class AdjustmentDataCollection {
  constructor() {
    this.accountContractIds = new Map();
    this.accountIds = new Set();
    this.adjustmentTypes = new Set();
    this.years = new Set();
    this.upcs = new Set();
  }
  add(adjustment) {
    (0, _utils.setMapSet)(this.accountContractIds, adjustment.accountId, adjustment.contractId);
    this.accountIds.add(adjustment.accountId);
    this.adjustmentTypes.add(adjustment.adjustmentType);
    this.years.add(adjustment.activityYear);
    this.years.add(adjustment.statementYear);
    if (adjustment.upc != null) {
      this.upcs.add(adjustment.upc);
      this.upcs.add(adjustment.upc.replace(/^0/, ""));
    }
  }
  addAll(chunk) {
    for (const adjustment of chunk) {
      this.add(adjustment);
    }
  }
}
exports.AdjustmentDataCollection = AdjustmentDataCollection;